import {
  ENVIRONMENT_INITIALIZER,
  InjectionToken,
  Provider,
  inject,
} from '@angular/core';
import {
  FeatureLoaderConfig,
  LoaderPolicyRule,
} from '../models/loader-policy.models';
import { LoaderPolicyService } from '../services/loader-policy.service';

export const FEATURE_LOADER_CONFIG = new InjectionToken<FeatureLoaderConfig>(
  'FEATURE_LOADER_CONFIG'
);

export const LOADER_POLICY_RULES = new InjectionToken<LoaderPolicyRule>(
  'LOADER_POLICY_RULES'
);

export function provideFeatureLoaderConfig(
  featureLoaderConfig: FeatureLoaderConfig
): Provider[] {
  return [
    {
      provide: FEATURE_LOADER_CONFIG,
      useValue: featureLoaderConfig,
      multi: true,
    },
    {
      provide: ENVIRONMENT_INITIALIZER,
      multi: true,
      useValue: () =>
        inject(LoaderPolicyService).registerFeatureLoaderConfig(featureLoaderConfig),
    },
  ];
}

export function provideLoaderPolicyRules(
  loaderPolicyRules: LoaderPolicyRule[]
): Provider[] {
  return loaderPolicyRules.flatMap((loaderPolicyRule) => [
    {
      provide: LOADER_POLICY_RULES,
      useValue: loaderPolicyRule,
      multi: true,
    },
    {
      provide: ENVIRONMENT_INITIALIZER,
      multi: true,
      useValue: () =>
        inject(LoaderPolicyService).registerLoaderPolicyRule(loaderPolicyRule),
    },
  ]);
}
